import React from 'react';
import { Box, Button, Step, StepLabel, Stepper, StepContent, Typography } from '@mui/material';

interface StepProps {
  label: string;
  component: React.ReactNode;
}

interface CustomVerticalStepperProps {
  title: string;
  steps: StepProps[];
  activeStep: number;
  onNext: () => void;
  onBack: () => void;
  save: () => void;
}

const CustomVerticalStepper: React.FC<CustomVerticalStepperProps> = ({title, steps, activeStep, onNext, onBack, save }) => {
  return (
    <Box width="100%" sx={{padding: '10px 0px 15px 15px'}}>
      <Typography variant={'h5'} sx={{marginBottom: '10px'}}>{title}</Typography>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel>{step.label}</StepLabel>
            <StepContent>
              {step.component}
              <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                <Button
                  variant="contained"
                  onClick={index === steps.length - 1 ? save : onNext}
                >
                  {index === steps.length - 1 ? 'Mentés' : 'Tovább'}
                </Button>
                {!(index === 0) && <Button
                  onClick={onBack}
                >
                  Vissza
                </Button>
                }
              </Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CustomVerticalStepper;